export default __webpack_public_path__ + "static/media/november.c4d93eb3.jpg";